<template>
  <router-link to="/ferramentas" class="back-button">
    <i class="fas fa-arrow-left"></i>{{ $t("tools.goBackToTools") }}
  </router-link>
</template>

<script>
export default {
  name: "BackButton"
};
</script>

<style scoped>
.back-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 15px;
  background-color: #f0512d;
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.back-button:hover {
  background-color: #d43d1d;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.back-button i {
  margin-right: 5px;
}
</style>
